import { useState, useEffect } from "react";
import { X, Sparkles, ArrowRight, Phone } from "lucide-react";
import { CONTACT } from "@/data/content";

export const OfferModal = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem("offer-seen")) return;

    const trigger = () => {
      if (sessionStorage.getItem("offer-seen")) return;
      sessionStorage.setItem("offer-seen", "1");
      setShow(true);
    };

    const onMouseOut = (e) => {
      if (e.clientY <= 0 && !e.relatedTarget) trigger();
    };
    const timer = setTimeout(trigger, 35000); // mobile / fallback
    document.addEventListener("mouseout", onMouseOut);

    return () => {
      clearTimeout(timer);
      document.removeEventListener("mouseout", onMouseOut);
    };
  }, []);

  if (!show) return null;

  return (
    <div
      data-testid="offer-modal"
      className="fixed inset-0 z-[70] bg-black/70 flex items-center justify-center p-4 animate-fade-up"
      onClick={() => setShow(false)}
    >
      <div
        className="relative bg-white rounded-sm max-w-lg w-full overflow-hidden shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          data-testid="offer-close"
          onClick={() => setShow(false)}
          className="absolute top-4 right-4 z-20 w-9 h-9 flex items-center justify-center text-white/80 hover:text-white hover:bg-white/15 rounded-sm transition-colors"
          aria-label="Close"
        >
          <X size={22} />
        </button>

        <div className="bg-[#1c4f9c] px-8 py-6 relative overflow-hidden">
          <div className="absolute inset-0 grain-overlay opacity-10 pointer-events-none" />
          <p className="relative flex items-center gap-2 text-sm font-bold uppercase tracking-[0.2em] text-[#ff6b70]">
            <Sparkles size={16} /> Limited-Time Offer
          </p>
          <h3 className="relative mt-2 text-2xl sm:text-3xl font-extrabold text-white leading-tight">
            Free On-Site Walkthrough + 15% Off Your First Month
          </h3>
        </div>

        <div className="px-8 py-7">
          <p className="text-base text-slate-600 leading-relaxed">
            Get a no-obligation facility walkthrough and a customized cleaning plan. Mention this offer and save <span className="font-bold text-[#1c4f9c]">15% on your first month</span> of service.
          </p>
          <div className="mt-7 flex flex-col sm:flex-row gap-3">
            <a
              href="#contact"
              data-testid="offer-cta"
              onClick={() => setShow(false)}
              className="flex-1 inline-flex items-center justify-center gap-2 bg-[#e02329] text-white font-bold py-3.5 px-6 rounded-sm hover:bg-[#c81e24] transition-colors duration-200"
            >
              Claim My Free Estimate <ArrowRight size={18} strokeWidth={2.5} />
            </a>
            <a
              href={CONTACT.phoneHref}
              data-testid="offer-call"
              onClick={() => setShow(false)}
              className="inline-flex items-center justify-center gap-2 border-2 border-[#1c4f9c] text-[#1c4f9c] font-bold py-3.5 px-6 rounded-sm hover:bg-[#1c4f9c] hover:text-white transition-colors duration-200"
            >
              <Phone size={18} strokeWidth={2.5} /> Call
            </a>
          </div>
          <p className="mt-4 text-center text-xs text-slate-400">No obligation. Serving commercial clients across Northeast Florida.</p>
        </div>
      </div>
    </div>
  );
};
